import React from 'react';
import StudentConsolidatedHistoryPanel from '../../../../components/students/StudentConsolidatedHistoryPanel/StudentConsolidatedHistoryPanel';

interface StudentHistoryStepProps {
  studentId: number;
}

const StudentHistoryStep: React.FC<StudentHistoryStepProps> = ({ studentId }) => (
  <StudentConsolidatedHistoryPanel studentId={studentId} />
);

export default StudentHistoryStep;
